import { DatePipe, CurrencyPipe, PercentPipe, DecimalPipe, AsyncPipe } from '@angular/common';

import { RoundNumberPipe } from './round-number.pipe';

/** Pipes global providers. */
// Needed for use in custom pipes.
export const pipesProviders = [DatePipe, CurrencyPipe, PercentPipe, DecimalPipe, AsyncPipe, RoundNumberPipe];
